import { ACTION_SET_ONLINE } from '../appReducer'

export default function connectivityEpic(action$, store, { serviceResolver }) {
  return action$
    .ofType(ACTION_SET_ONLINE)
    .do((action) => {
      const toastService = serviceResolver('toastService')
      if (action.payload === true) {
        toastService.hideOffline()
      } else {
        toastService.showOffline()
      }
    })
    .filter(() => false)
}
